import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link, Redirect, useHistory } from 'react-router-dom'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import ErrorDialog from 'components/ErrorDialog'
import Panel from 'components/Panel'
import useAuth from 'lib/auth'
import { httpsCallable } from 'lib/functions'

export default function UserEditPage() {
  const { user, setUser } = useAuth()
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { displayName: user?.displayName || '' },
  })
  const history = useHistory()
  const [error, setError] = useState(null)
  const [checked, setChecked] = useState(false)

  const submit = async ({ displayName }) => {
    return httpsCallable('callable-user-update')({ displayName })
      .then(res => {
        setUser(current => ({ ...current, ...res.data }))
        history.push('/')
      })
      .catch(setError)
  }

  if (!user) {
    return <Redirect to="/" />
  }

  return (
    <Panel centered>
      <Box sx={{ px: 3 }}>
        <form onSubmit={handleSubmit(submit)}>
          <Typography align="center" sx={{ mb: 3 }} variant="h2">
            ユーザー{user.displayName ? '設定' : '登録'}
          </Typography>
          <Controller
            name="displayName"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                sx={{ mb: 2 }}
                label="氏名"
                placeholder="三和太郎"
                disabled={isSubmitting}
                helperText={errors.displayName && '必須項目です'}
              />
            )}
          />
          {user.displayName === null && (
            <FormGroup sx={{ mb: 2 }}>
              <FormControlLabel
                control={<Checkbox color="primary" onChange={e => setChecked(e.target.checked)} />}
                label={
                  <>
                    <Link to="/terms" target="_blank">
                      利用規約
                    </Link>
                    および
                    <Link to="/policy" target="_blank">
                      プライバシーポリシー
                    </Link>
                    に同意
                  </>
                }
              />
            </FormGroup>
          )}
          <Button
            variant="contained"
            fullWidth
            color="primary"
            size="large"
            style={{ height: 50 }}
            type="submit"
            disabled={isSubmitting || (!user.displayName && !checked)}
          >
            {isSubmitting ? <CircularProgress size={24} /> : user.displayName ? '更新' : '登録'}
          </Button>
          {Boolean(error) && (
            <ErrorDialog
              error="エラーが発生しました。大変お手数ですがしばらくしてから再度お試しください"
              onClose={() => setError(null)}
            />
          )}
        </form>
      </Box>
    </Panel>
  )
}
